import { HugeiconsIcon } from "@hugeicons/react";
import { PlayIcon } from "@hugeicons-pro/core-solid-rounded";
import { PreviewFrame } from "./PreviewFrame";

// Deterministic waveform so the teaser renders identically on every visit.
const WAVEFORM_HEIGHTS = [
  6, 10, 16, 22, 14, 8, 12, 20, 26, 18, 10, 6, 9, 15, 24, 28, 20, 12, 7, 11, 17,
  23, 15, 9, 6, 13, 21, 27, 19, 11, 7, 10, 16, 22, 14, 8, 12, 19, 25, 17, 9, 6,
  8, 14, 20, 12, 7, 5
];

const TRANSCRIPT: { speaker: string; text: string }[] = [
  {
    speaker: "Agent",
    text: "Hi, thanks for calling Blue Sky Apartments! How can I help you today?"
  },
  {
    speaker: "Angel Donin",
    text: "Hi, I'm looking for a 2-bedroom. Do you have anything available?"
  },
  {
    speaker: "Agent",
    text: "Yes, we currently have two 2-bedroom units available starting next month. Would you like to schedule a tour?"
  }
];

/**
 * Teaser for the locked AI Leasing agent card in the add-agent wizard (Figma
 * BoomCRM-Paywall 202:6089): a call recording with its transcript, on the Pro
 * gradient frame.
 */
export const AiLeasingAgentPreview = () => (
  <PreviewFrame height={363} noInnerCard badge="pro">
    <div
      className="absolute left-[24px] top-[66px] flex w-[586px] flex-col gap-4 overflow-hidden rounded-lg bg-white px-6 pb-5 pt-6"
      style={{
        boxShadow:
          "0px 12px 16px -4px rgba(28,29,34,0.08), 0px 4px 6px -2px rgba(28,29,34,0.03)"
      }}
    >
      {/* Recording row */}
      <div className="flex items-center gap-4 rounded-lg border border-alpha-100 px-4 py-3">
        <span
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 text-white"
          aria-hidden="true"
        >
          <HugeiconsIcon icon={PlayIcon} size={16} />
        </span>
        <div
          className="flex h-8 flex-1 items-center gap-[3px]"
          aria-hidden="true"
        >
          {WAVEFORM_HEIGHTS.map((height, idx) => (
            <span
              key={idx}
              className="w-[3px] shrink-0 rounded-full bg-content-200"
              style={{ height: `${height}px` }}
            />
          ))}
        </div>
        <span className="shrink-0 text-[13px] font-medium leading-[18px] text-content-400">
          0:00 / 0:05
        </span>
      </div>

      {/* Transcript */}
      <div className="flex flex-col gap-3">
        <p className="text-[13px] font-medium leading-[18px] text-content-400">
          Transcript
        </p>
        {TRANSCRIPT.map((line, idx) => (
          <p
            key={line.speaker + idx}
            className="text-[13px] font-medium leading-[18px] text-content-1000"
            style={
              idx === TRANSCRIPT.length - 1
                ? {
                    backgroundImage:
                      "linear-gradient(180deg, #1c1d22 0%, rgba(28,29,34,0.15) 100%)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    color: "transparent"
                  }
                : undefined
            }
          >
            <span className="text-content-400">{line.speaker}: </span>
            {line.text}
          </p>
        ))}
      </div>
    </div>
  </PreviewFrame>
);
